import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f83da3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title__inner" }
const _hoisted_2 = { class: "subtitle__inner" }
const _hoisted_3 = { class: "article__quantity" }

import { computed } from 'vue'
import { IonItem, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonImg, } from '@ionic/vue';
import { IScannedArticle } from '@/const/types/article';
import { IAggregatedPlacementCompact } from '@/const/types/placement';

interface Props {
    article: IScannedArticle | IAggregatedPlacementCompact;
    isNew?: Boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleQuantityCardBase',
  props: {
    article: null,
    isNew: null
  },
  setup(__props: any) {

const props = __props as {
    article: IScannedArticle | IAggregatedPlacementCompact;
    isNew?: Boolean
};



function isScannedArticle(object: IScannedArticle | IAggregatedPlacementCompact): object is IScannedArticle {
    return 'connectedArticle' in object;
}

const imageUrl = computed(() => {
    return isScannedArticle(props.article)
        ? props.article.connectedArticle.imageUrl
        : props.article.imageUrl
})

const name = computed(() => {
    return isScannedArticle(props.article)
        ? props.article.connectedArticle.name
        : props.article.name
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), { class: "ion-no-padding" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCard), {
        class: _normalizeClass(["card__outer", { 'new__article': __props.isNew }])
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_unref(IonImg), {
            class: "card__image",
            src: _unref(imageUrl)
          }, null, 8, ["src"]), [
            [_vShow, _unref(imageUrl)]
          ]),
          _createVNode(_unref(IonCardHeader), { class: "card__header" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardTitle), { class: "title__outer" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("span", null, _toDisplayString(_unref(name)), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCardSubtitle), { class: "subtitle__outer" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", null, _toDisplayString(props.article.code), 1),
                    _createElementVNode("span", _hoisted_3, [
                      _renderSlot(_ctx.$slots, "right")
                    ])
                  ])
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["class"])
    ]),
    _: 3
  }))
}
}

})